import request from '@/api/request'
/**
 * 获取全局数据字典
 */
export function dictDataApi () {
  return request({
    url: '/dict/data',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/dict/index.js